import { Action } from 'vuex-class';
import * as API from '../../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const sendGuestMail = async ({commit, dispatch}, {eventId, templateId, guestId}) => {
  try {
    await API.sendGuestMail(eventId, templateId, guestId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendAllHostsMail = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendAllHostsMail(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendHostMail = async ({commit, dispatch}, {eventId, templateId, hostId}) => {
  try {
    await API.sendHostMail(eventId, templateId, hostId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendAllGuestsMail = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendAllGuestsMail(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendConfirmedGuestsMail = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendConfirmedGuestsMail(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendPendingGuestsMail = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendPendingGuestsMail(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const sendTestMail = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendTestMail(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};


// @Action('admin/events/sendToMissingReplies') private sendToMissingReplies!: any;
// @Action('admin/events/sendToAllDenies') private sendToAllDenies!: any;

export const sendToMissingReplies = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendToMissingReplies(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

export const sendToAllDenies = async ({commit, dispatch}, {eventId, templateId}) => {
  try {
    await API.sendToAllDenies(eventId, templateId);
    dispatch('common/snackbar/success', 'Email wurde versandt', {root: true});
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};
